import { jsx as _jsx } from "react/jsx-runtime";
import { IconHelpFilled, IconIdCardFilled, IconLogout, IconMotorcycle, IconSquareMenu, IconUser, IconUtensils, } from "../components/icons";
export var DEFAULT_THEME = {
    colors: {
        primary: {
            lightest: "#e5a1a4",
            lighter: "#db6e72",
            light: "#d13f45",
            default: "#c8131b",
            dark: "#94090f",
            darker: "#610206",
        },
        red: {
            lightest: "#e5a1a4",
            lighter: "#db6e72",
            light: "#d13f45",
            default: "#c8131b",
            dark: "#94090f",
            darker: "#610206",
        },
        yellow: {
            lightest: "#ffebc8",
            lighter: "#ffd894",
            light: "#ffc561",
            default: "#ffb32f",
            dark: "#cc8c1d",
            darker: "#99670f",
        },
        green: {
            lightest: "#bce3de",
            lighter: "#89d9cf",
            light: "#59cfc1",
            default: "#2ec9b7",
            dark: "#1d9688",
            darker: "#0f635a",
        },
        blue: {
            lightest: "#99dfff",
            lighter: "#66cfff",
            light: "#33bfff",
            default: "#01afff",
            dark: "#018ccc",
            darker: "#016999",
        },
        orange: {
            lightest: "#FFD8BD",
            lighter: "#FFB98A",
            light: "#FF9B57",
            default: "#FF7D24",
            dark: "#CC5F14",
            darker: "#994409",
        },
        second_green: {
            lightest: "#A5C7AF",
            lighter: "#77BD8B",
            light: "#4DB26A",
            default: "#27A84C",
            dark: "#167532",
            darker: "#0A421A",
        },
        neutral: {
            white: "#ffffff",
            lightest: "#f6f6f6",
            lighter: "#ededed",
            light: "#c6c6c6",
            default: "#7a7a7a",
            dark: "#545454",
            darker: "#222222",
            black: "#000000",
        },
    },
    shadows: {
        lighter: "0px 0px 2px 0px #0000001F, 0px 1px 2px 0px #00000024;",
        light: "0px 0px 2px 0px #0000001F, 0px 2px 4px 0px #00000024;",
        default: "0px 0px 2px 0px #0000001F, 0px 4px 8px 0px #00000024;",
        dark: "0px 0px 2px 0px #0000001F, 0px 8px 16px 0px #00000024;",
        darker: "0px 0px 8px 0px #00000033, 0px 10px 25px 0px #00000024;",
    },
    typography: {
        family: {
            default: '"Poppins", sans-serif',
        },
        weights: {
            regular: 400,
            medium: 500,
            semibold: 600,
            bold: 700,
        },
    },
    spacing: {
        xxs: "4px",
        xs: "8px",
        s: "16px",
        m: "24px",
        l: "32px",
        xl: "40px",
        xxl: "48px",
    },
    radius: {
        s: "4px",
        m: "8px",
        l: "12px",
        xl: "16px",
        xxl: "24px",
    },
    components: {
        fieldInfo: {
            fontSize: {
                desktop: "12px",
                tablet: "14px",
                totem: "16px",
            },
        },
        input: {
            label: {
                fontSize: {
                    desktop: "16px",
                    tablet: "18px",
                    totem: "20px",
                },
            },
            input: {
                fontSize: {
                    desktop: "14px",
                    tablet: "16px",
                    totem: "18px",
                },
                height: {
                    desktop: "40px",
                    tablet: "48px",
                    totem: "56px",
                },
                borderRadius: {
                    desktop: "8px",
                    tablet: "12px",
                    totem: "16px",
                },
                padding: {
                    desktop: "8px 16px",
                    tablet: "8px 16px",
                    totem: "8px 12px",
                },
            },
        },
        select: {
            padding: {
                desktop: "4px 16px",
                tablet: "4px 16px",
                totem: "4px 12px",
            },
        },
        button: {
            fontSize: {
                medium: "14px",
                small: "12px",
                large: "14px",
                tablet: "16px",
                totem: "18px",
            },
            height: {
                large: "40px",
                medium: "32px",
                small: "24px",
                tablet: "48px",
                totem: "56px",
            },
            padding: {
                large: {
                    text: "0 24px",
                    icon: "0 8px",
                    textAndIcon: "0 24px 0 16px",
                },
                medium: {
                    text: "0 16px",
                    icon: "0 8px",
                    textAndIcon: "0 12px 0 8px",
                },
                small: {
                    text: "0 8px",
                    icon: "0 4px",
                    textAndIcon: "0 6px 0 4px",
                },
                tablet: {
                    text: "0 24px",
                    icon: "0 8px",
                    textAndIcon: "0 24px 0 16px",
                },
                totem: {
                    text: "0 32px",
                    icon: "0 8px",
                    textAndIcon: "0 32px 0 16px",
                },
            },
            iconSize: {
                large: "24px",
                medium: "20px",
                small: "16px",
                tablet: "24px",
                totem: "24px",
            },
            iconPadding: {
                large: 8,
                medium: 8,
                small: 4,
                tablet: 24,
                totem: 32,
            },
        },
    },
    device: "desktop",
};
// Usado em alguns componentes como Switch e Radio Button
export var LABEL_POSITIONS = {
    top: "column",
    bottom: "column-reverse",
    left: "row",
    right: "row-reverse",
};
export var MENU_OBJECT = {
    profile: {
        name: "Restaurante de teste",
        image: "https://via.placeholder.com/150",
        text: "Perfil",
        path: "/profile",
        icon: _jsx(IconUser, {}),
        displayType: "page",
        subitems: [
            { text: "Editar meu negócio", path: "/info" },
            { text: "Alterar perfil da conta", path: "/user-profile" },
            { text: "Tarefas", path: "/tasks" },
        ],
    },
    categories: [
        {
            text: "Operação",
            path: "/operation",
            icon: _jsx(IconUtensils, {}),
            displayType: "sidebar",
            subitems: [
                {
                    text: "Mesa / Balcão",
                    path: "",
                },
                {
                    text: "Caixa",
                    path: "/cashier",
                },
                {
                    text: "Comandas",
                    path: "/bills",
                },
                {
                    text: "KDS",
                    path: "/kds",
                },
            ],
        },
        {
            text: "Delivery",
            path: "/delivery",
            icon: _jsx(IconMotorcycle, {}),
            subitems: [
                {
                    text: "Pedidos",
                    path: "/orders",
                    displayType: "sidebar",
                },
                {
                    text: "Horário de funcionamento",
                    path: "/opening-hours",
                    displayType: "page",
                },
                {
                    text: "Endereços",
                    path: "/addresses",
                    displayType: "page",
                },
                {
                    text: "Agendamento",
                    path: "/scheduling",
                    displayType: "page",
                },
                {
                    text: "Cupons",
                    path: "/coupons",
                    displayType: "page",
                },
                {
                    text: "Motoboys",
                    path: "/motoboys",
                    displayType: "page",
                },
                {
                    text: "Configurações",
                    path: "/config",
                },
            ],
        },
        {
            text: "Cadastros",
            path: "/register",
            icon: _jsx(IconIdCardFilled, {}),
            displayType: "sidebar",
            subitems: [
                {
                    text: "Cardápio",
                    path: "/menu",
                },
                {
                    text: "Estoque",
                    path: "/stock",
                    displayType: "sidebar",
                },
                {
                    text: "Vinculos iFood ",
                    path: "/ifood",
                },
                {
                    text: "Vinculos Fiscais",
                    path: "/fiscal",
                },
                {
                    text: "Funcionários",
                    path: "/employees",
                    displayType: "page",
                },
                {
                    text: "Impressoras e outros",
                    path: "/printers",
                    displayType: "page",
                },
            ],
        },
        {
            text: "Ver mais",
            path: "/search",
            icon: _jsx(IconSquareMenu, {}),
            displayType: "sidebar",
        },
        {
            text: "Fiscal",
            path: "/fiscal",
            displayType: "page",
            subitems: [
                { text: "Manifesto de Notas", path: "/manifest" },
                { text: "Entrada de Notas", path: "/entries" },
                { text: "Notas Emitidas", path: "/issued" },
                { text: "Notas Devolvidas", path: "/returned" },
                { text: "Grupos fiscais", path: "/groups" },
            ],
        },
        {
            text: "Estoque",
            path: "/register/stock",
            displayType: "page",
            subitems: [
                { text: "Insumos", path: "" },
                { text: "Transferência de Estoque", path: "/transfers" },
                { text: "Fornecedores", path: "/suppliers" },
            ],
        },
        {
            text: "Perfil",
            path: "/profile",
            displayType: "page",
            subitems: [
                { text: "Editar meu negócio", path: "/info" },
                { text: "Alterar perfil da conta", path: "/user-profile" },
                { text: "Tarefas", path: "/tasks" },
            ],
        },
        {
            text: "Ajuda",
            path: "/help",
            icon: _jsx(IconHelpFilled, {}),
            displayType: "sidebar",
            barPosition: "footer",
        },
        {
            text: "Sair",
            icon: _jsx(IconLogout, {}),
            displayType: "sidebar",
            barPosition: "footer",
            function: function () {
                console.log("Sair");
            },
        },
    ],
};
export var MENU_CONSTANTS = {
    TOOLTIPS: {
        CLOSE_MENU: "Fechar menu",
        OPEN_MENU: "Abrir menu",
    },
    SEARCH: {
        PLACEHOLDER: "Buscar",
        NO_RESULTS: "Nenhum resultado encontrado",
    },
};
export var MENU_ITEMS = [
    {
        id: "home",
        text: "Home",
        path: "/",
    },
];
//# sourceMappingURL=consts.js.map